export default {
  title: 'Faktury zamówień',
  list: {
    empty_list: {
      title: 'Brak faktur zamówień.',
    },
    fields: {
      id: 'Id',
      total: 'Suma',
      date: 'Data',
    },
  },
  export_modal: {
    title: 'Filtr',
    start_date: {
      title: 'Data początkowa',
      placeholder: 'data',
    },
    end_date: {
      title: 'Data końcowa',
      placeholder: 'data',
    },
    button: {
      title1: 'Zastosuj',
      title2: 'Zamknij',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
